import { CircularProgress, Dialog, DialogContent } from "@material-ui/core";
import IssueTrackerView from "features/IssuesTracker/IssueTrackerView/IssueTrackerView";
import { useGetIssueTrackerByIdQuery } from "features/IssuesTracker/issuesTrackerSlice";
import { linkedTicketDialogStyles } from "./LinkedTicketDialogStyles";

const LinkedTicketDialog = ({ ticketId, onClose, onOpenWorkOrder }) => {
    const classes = linkedTicketDialogStyles();
    const { data: ticketResult } = useGetIssueTrackerByIdQuery({ id: ticketId }, { skip: !ticketId });
    const ticket = ticketResult?.[0];

    if (!ticketId) {
        return null;
    }

    if (!ticket) {
        return (
            <Dialog open onClose={onClose} maxWidth="lg" fullWidth>
                <DialogContent className={classes.loading}>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
        );
    }

    return (
        <IssueTrackerView
            issueTracker={ticket}
            withDialog
            onClose={onClose}
            onOpenWorkOrder={onOpenWorkOrder}
        />
    );
};

export default LinkedTicketDialog;
